import { ContextApi } from 'contexts/Localization/types'
import { PageMeta } from './types'

export const DEFAULT_META: PageMeta = {
  title: 'DarkMatter',
  description: 'Dark Matter Swap for DMD',
  image: 'https://www.darkmatterdefi.com/images/hero.jpg',
}

export const getCustomMeta = (path: string, t: ContextApi['t']): PageMeta => {
  switch (path) {
    case '/':
      return {
        title: `${t('Home')} | ${t('DarkMatter')}`,
      }
    case '/presale':
      return {
        title: `${t('Presale')} | ${t('DarkMatter')}`,
      }
    case '/nft':
      return {
        title: `${t('NFT')} | ${t('DarkMatter')}`,
      }
    case '/farms':
      return {
        title: `${t('Farms')} | ${t('DarkMatter')}`,
      }
    case '/pools':
      return {
        title: `${t('Pools')} | ${t('DarkMatter')}`,
      }
    default:
      return null
  }
}
